import * as Yup from 'yup';

const businessFormValidationSchema = Yup.object().shape({
  // 항상 필수값인 필드들
  bnSubCatCd: Yup.mixed()
    .test(
      'isStringOrNumber',
      '상위 카테고리를 선택해주세요.',
      (value) => (typeof value === 'string' && value !== '') || typeof value === 'number',
    )
    .required('상위 카테고리를 선택해주세요.'),
  pipelineCd: Yup.string().required('파이프라인을 선택해주세요.'),
  useYn: Yup.boolean().required('사용여부를 선택해주세요.'),
  lang: Yup.string().required('언어를 선택해주세요.'),
  thumbPath: Yup.string().required('썸네일 이미지를 등록해주세요.'),
  detailPath: Yup.array()
    .min(1, '상세 이미지를 등록해주세요.')
    .required('상세 이미지를 등록해주세요.'),
});

export default businessFormValidationSchema;
